
export const EditStaffOrderModalList = [
    // {
    //     label: "姓名",
    //     value: 'name',
    //     key: "name",
    //     type: "text",
    //     placeholder: "請輸入姓名",
    //     required: true
    // },
    {
        label: "公司",
        value: "company",
        key: "company",
        type: "text",
        placeholder: "請輸入公司名稱",
        required: true,
        mode: "company",
        disabled: true,
    },
    {
        label: "手機號碼",
        value: 'phone',
        key: "phone",
        type: "number",
        placeholder: "請輸入手機號碼",
        required: true
    },
    {
        label: "家具數量",
        value: 'furnitureCount',
        key: "furnitureCount",
        type: "number",
        min: 0,
        placeholder: "請輸入要運送的家具數量",
        required: true,
    },
    {
        label: "開始時間",
        value: 'usedAt',
        key: "usedAt",
        type: "datetime-local",
        placeholder: "請輸入開始使用時間",
        required: true,
    },
    {
        label: "結束時間",
        value: 'finishAt',
        key: "finishAt",
        type: "datetime-local",
        placeholder: "請輸入結束時間",
        required: true,
    },
    {
        label: "歸還時間",
        value: 'returnAt',
        key: "returnAt",
        type: "datetime-local",
        placeholder: "請輸入歸還時間",
        // required: true,
    },
]

export const CreateStaffOrderModalList = [
    // {
    //     label: "姓名",
    //     name: "name",
    //     type: "text",
    //     placeholder: "請輸入姓名",
    //     required: true,
    // },
    {
        label: "公司",
        name: "company",
        type: "text",
        placeholder: "請輸入公司名稱",
        required: true,
        mode: "company",
        disabled: true,
    },
    {
        label: "手機號碼",
        name: "phone",
        type: "number",
        placeholder: "請輸入手機號碼",
        required: true,
    },
    {
        label: "家具數量",
        name: "furnitureCount",
        type: "number",
        min: 0,
        placeholder: "請輸入要運送的家具數量",
        required: true
    },
    {
        label: "開始時間",
        name: "usedAt",
        type: "datetime-local",
        placeholder: "請輸入開始使用時間",
        required: true
    },
    {
        label: "結束時間",
        name: "finishAt",
        type: "datetime-local",
        placeholder: "請輸入結束時間",
        required: true
    },
    {
        label: "歸還時間",
        name: "returnAt",
        type: "datetime-local",
        placeholder: "請輸入歸還時間",
        // required: true
    },
]